/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

interface Props {
  className: any;
}

export const SavedIcon = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask height="20" id="mask0_1317_7480" maskUnits="userSpaceOnUse" width="20" x="0" y="0">
        <rect fill="#D9D9D9" height="20" width="20" />
      </mask>
      <g mask="url(#mask0_1317_7480)">
        <path
          d="M10 17.5L8.79167 16.4167C7.38889 15.1528 6.22917 14.0625 5.31251 13.1458C4.39584 12.2292 3.66667 11.4062 3.12501 10.6771C2.58334 9.94791 2.20487 9.27777 1.98959 8.66666C1.77431 8.05555 1.66667 7.43055 1.66667 6.79166C1.66667 5.48611 2.10417 4.39583 2.97917 3.52083C3.85417 2.64583 4.94445 2.20833 6.25001 2.20833C6.97223 2.20833 7.65973 2.36111 8.31251 2.66666C8.96528 2.97222 9.52778 3.40277 10 3.95833C10.4722 3.40277 11.0347 2.97222 11.6875 2.66666C12.3403 2.36111 13.0278 2.20833 13.75 2.20833C15.0556 2.20833 16.1458 2.64583 17.0208 3.52083C17.8958 4.39583 18.3333 5.48611 18.3333 6.79166C18.3333 7.43055 18.2257 8.05555 18.0104 8.66666C17.7951 9.27777 17.4167 9.94791 16.875 10.6771C16.3333 11.4062 15.6042 12.2292 14.6875 13.1458C13.7708 14.0625 12.6111 15.1528 11.2083 16.4167L10 17.5Z"
          fill="#FF7341"
        />
      </g>
    </svg>
  );
};
